export const colors = {
    primary: '#005F60',
    accent: '#C99D5F',
    white: '#FFFFFF',
    lightGrey: '#F4F4F4',
    darkGrey: '#333333',
};

export const gradients = {
    heroOverlay: `linear-gradient(rgba(0, 95, 96, 0.7), rgba(0, 95, 96, 0.3))`,
    transparentToPrimary: `linear-gradient(to bottom, transparent, ${colors.primary})`,
}; 